import React, { useEffect, useState } from 'react';
import {Form, Input, Checkbox, Select } from 'antd';
import InputWithSearchModal from '../../components/InputWithSearchModal';
import UserFilter from '../UserFilter';
import UserSelector from '../UserSelector';
import { READ, errorCatch, useUserContext } from 'fennec-ui';
import { isAnyFederationAdministrator } from '../../../common/Tool';
 
const { Option } = Select;

export default function NovieYacheikiUslugi(props) {
    const { auth, object, form } = props;
    const [prilozhenie, setPrilozhenie] = useState();
    const user = useUserContext();

    useEffect(() => {
        form.resetFields();
        READ(auth, "TipiPrilozhenii", ({ data }) => {
            setPrilozhenie(data)
        }, errorCatch)
    }, []);

    const prilozhenieOptions = prilozhenie?.map((i) => <Option key={i.ID} label={i.name} value={i.ID}>{i.name}</Option>);

    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <Form.Item label="Название"
                    name="nazvanie"
                    rules={[{ required: true, message: 'Пожалуйста, укажите промокод!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Описание"
                    name="opisanie"
                    rules={[{ required: false, message: 'Пожалуйста, укажите описание!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="zaregistrirovanniiPolzovatel"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Зарегистрированный пользователь
                    </Checkbox>
                </Form.Item>
                {/* <Form.Item
                    name="registratsiyaKollektiva"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Регистрация коллектива
                    </Checkbox>
                </Form.Item> */}
                <Form.Item label="Регистрация на соревнования"
                    name="prilozhenieID"
                    rules={[{ required: false, message: 'Пожалуйста, укажите регистрацию на соревнования!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                        }
                    >
                        {prilozhenieOptions}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="zritel"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Зритель
                    </Checkbox>
                </Form.Item>
                <Form.Item
                    name="neUchitivatVAgentskikh"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Не учитывать в агентских
                    </Checkbox>
                </Form.Item>
                {(isAnyFederationAdministrator(user)) && <Form.Item
                    name="neUchitivatVOborotakh"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Не учитывать в оборотах
                    </Checkbox>
                </Form.Item>}
                <Form.Item
                    name={"artist"}
                    label={"Артист"}
                    rules={[{ required: false, message: 'Укажите aртистa!' }]}
                >
                    <InputWithSearchModal valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{ }}
                        searchForm={UserFilter}
                        selectForm={UserSelector} />
                </Form.Item>
            </Form>
        </>
    );
}
